import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { FullscreenContainerModalComponent } from './fullscreen-modal-container/fullscreen-container-modal.component';

export class FullscreenModalRef {
  private _beforeClose = new Subject<any>();
  private _afterClosed = new Subject<any>();
  _afterOpened = new Subject<any>();

  componentInstance: FullscreenContainerModalComponent = {} as any;
  constructor(private overlayRef: OverlayRef) {}

  afterClosed(): Observable<void> {
    return this._afterClosed.asObservable();
  }
  afterOpened(): Observable<void> {
    return this._afterOpened.asObservable();
  }

  beforeClose(): Observable<void> {
    return this._beforeClose.asObservable();
  }

  close(data?: any) {
    this.componentInstance.animationStateChanged
      .pipe(
        filter(event => event.phaseName === 'start'),
        take(1)
      )
      .subscribe(() => {
        this._beforeClose.next(data);
        this._beforeClose.complete();
        this.overlayRef.detachBackdrop();
      });

    this.componentInstance.animationStateChanged
      .pipe(
        filter(
          event => event.phaseName === 'done' && event.toState === 'leave'
        ),
        take(1)
      )
      .subscribe(() => {
        this.overlayRef.dispose();
        this._afterClosed.next(data);
        this._afterClosed.complete();

        this.componentInstance = this.componentInstance
          ? null as any
          : this.componentInstance;
      });

    this.componentInstance.startExitAnimation();
  }
}
